import React, { forwardRef, memo } from 'react'

const ChatBubbleIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width="181.3"
      height="147.7"
      viewBox="0 0 259 211"
      fill="none"
      {...props}>
      <path
        d="M10.024 37.8389H248.925C254.461 37.8389 258.949 42.3267 258.949 47.8627V144.205C258.949 149.741 254.461 154.229 248.925 154.229H229.42C223.884 154.229 219.396 158.717 219.396 164.253V203.28C219.396 206.168 215.981 207.696 213.828 205.771L159.034 156.78C157.196 155.137 154.818 154.229 152.353 154.229H10.0241C4.48806 154.229 0.000244141 149.741 0.000244141 144.205V47.8627C0.000244141 42.3267 4.48805 37.8389 10.024 37.8389Z"
        fill="#78BE20"
      />
      <circle
        cx="56.7"
        cy="56.7"
        r="56.7"
        transform="matrix(-0.994496 0.104773 0.104773 0.994496 218.327 0.25)"
        fill="#D15A19"
      />
      <mask
        id="chatbubble-mask0"
        maskUnits="userSpaceOnUse"
        x="111"
        y="5"
        width="114"
        height="115">
        <circle
          cx="56.7"
          cy="56.7"
          r="56.7"
          transform="matrix(-0.994496 0.104773 0.104773 0.994496 218.327 0.25)"
          fill="#fff"
        />
      </mask>
      <g mask="url(#chatbubble-mask0)">
        <path
          d="M216.504 30.5039L191.728 33.1141"
          stroke="white"
          strokeWidth="1.745"
        />
        <path
          d="M218.074 92.9639L193.299 95.5741"
          stroke="white"
          strokeWidth="1.745"
        />
        <path
          d="M232.285 61.4063L201.315 64.669"
          stroke="white"
          strokeWidth="1.745"
        />
      </g>
      <ellipse
        cx="52.317"
        cy="57.299"
        rx="52.317"
        ry="57.299"
        transform="matrix(-0.994496 0.104773 0.104773 0.994496 203.461 1.817)"
        fill="#FFA300"
      />
      <circle
        cx="46.928"
        cy="46.928"
        r="46.928"
        transform="matrix(-0.927337 0.374227 0.374227 0.927337 91.782 64.569)"
        fill="#D15A19"
      />
      <mask
        id="chatbubble-mask1"
        maskUnits="userSpaceOnUse"
        x="18"
        y="78"
        width="95"
        height="95">
        <circle
          cx="46.928"
          cy="46.928"
          r="46.928"
          transform="matrix(-0.927337 0.374227 0.374227 0.927337 91.782 64.569)"
          fill="#fff"
        />
      </mask>
      <g mask="url(#chatbubble-mask1)">
        <path
          d="M97.217 89.0605L78.096 96.7769"
          stroke="white"
          strokeWidth="1.745"
        />
        <path
          d="M112.683 138.405L93.5623 146.122"
          stroke="white"
          strokeWidth="1.745"
        />
        <path
          d="M116.808 110.059L92.907 119.704"
          stroke="white"
          strokeWidth="1.745"
        />
      </g>
      <ellipse
        cx="43.301"
        cy="47.424"
        rx="43.301"
        ry="47.424"
        transform="matrix(-0.927337 0.374227 0.374227 0.927337 80.309 69.2)"
        fill="#FFA300"
      />
    </svg>
  )
)

ChatBubbleIcon.displayName = 'ChatBubbleIcon'

export default memo(ChatBubbleIcon)
